const routineData = [
    [
      {
        p: 'p3',
        subject: 'Routine is not available. Somthing missing. Maybe this class is not exists. Select your routine again.',
        status: 404,
      }
    ],
  ]
  
  export default routineData;